import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Library() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/library").then((r) => {
      setItems(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[var(--paper)]" data-testid="library-page">
      <Navbar />
      <section className="max-w-[1280px] mx-auto px-6 sm:px-10 pt-12 pb-10">
        <span className="eyebrow">◆ Your library</span>
        <h1 className="h-display text-[44px] sm:text-[60px] mt-3">
          {items.length === 0 ? "0 routes ready." : `${items.length} ${items.length === 1 ? "route" : "routes"} ready.`}
        </h1>
        <p className="text-[14px] text-[var(--ink2)] mt-2">
          Logged in as <strong>{user?.name}</strong>
        </p>
      </section>

      <section className="max-w-[1280px] mx-auto px-6 sm:px-10 pb-20">
        {loading ? (
          <div className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--ink3)]">◆ Loading library…</div>
        ) : items.length === 0 ? (
          <div
            data-testid="empty-library"
            className="bg-[var(--card)] border-[1.5px] border-dashed border-[var(--line)] rounded-[24px] py-20 px-6 text-center"
          >
            <span className="eyebrow">◆ Empty library</span>
            <h2 className="h-display text-[32px] mt-3 max-w-[480px] mx-auto">
              Your library is empty.
            </h2>
            <p className="text-[14px] text-[var(--ink2)] mt-3 max-w-[420px] mx-auto leading-[1.6]">
              Browse the marketplace to find your first itinerary.
            </p>
            <Link to="/explore" data-testid="empty-cta" className="btn btn-solid mt-7 inline-flex">
              Browse marketplace →
            </Link>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="library-grid">
            {items.map((it) => (
              <Link
                key={it.itinerary_id}
                to={`/library/${it.slug}`}
                data-testid={`library-card-${it.slug}`}
                className="card group"
              >
                <div
                  className="card-img"
                  style={{
                    backgroundImage: `url(${it.cover_url})`,
                    backgroundSize: "cover",
                  }}
                >
                  {it.badge && <div className="stamp-mini">{it.badge}</div>}
                </div>
                <div className="card-body">
                  <div className="card-region">{it.destination_country} · {it.duration_days} Days</div>
                  <div className="card-title">{it.title}</div>
                  <div className="card-foot">
                    <div className="card-by">
                      <div className="av-sm" style={{ background: it.seller?.accent_color || "var(--ink)" }}>
                        {it.seller?.initials}
                      </div>
                      <span>by {it.seller?.name}</span>
                    </div>
                    <span className="mono text-[10px] tracking-[0.15em] uppercase text-[var(--green)] font-semibold">Open →</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
